import authRoute from '@/configs/routes.config/authRoute'
import { useLocation, useMatch } from 'react-router-dom'
import AuthLayout from './AuthLayout'
import type { CommonProps } from '@/@types/common'

// Auth pages that bring their own full-screen layout and must not be wrapped
// in AuthLayout's side-image frame.
const fullScreenAuthPaths = [
    '/sign-in-v2',
    '/sendotp',
    '/forgot-password',
    '/resetotp',
    '/viewrequestdetails',
    '/reg_face',
    // The visitor self-registration pages (/visitor/qr, /visitor/register)
    // never reach this layout at all -- Layouts.tsx renders them bare.
]
// import PlainTopbar from './PostLoginLayout/components/PlainTopbar'
const PreLoginLayout = ({ children }: CommonProps) => {
    const empidMatch = useMatch('/empeid/:id/:token')
    const location = useLocation()

    const { pathname } = location

    const isAuthPath =
        authRoute.some((route) => route.path === pathname) &&
        !fullScreenAuthPaths.includes(pathname)
    // const changepasswordClass = location.pathname === '/change-password' || location.pathname === '/change-otp'  ? 'justify-normal' : 'lg:justify-normal justify-center';
    // const changeotpClass = location.pathname === '/change-otp'  ? 'justify-normal' : 'lg:justify-normal justify-center';
    const qrloginClass =
        location.pathname === '/qrlogin' || location.pathname === '/home'
            ? 'justify-center'
            : 'justify-normal'
    return (
        <div className={`flex ${qrloginClass} flex-auto flex-col h-[100vh]`}>
            {/* { (location.pathname === '/change-password' || location.pathname === '/change-otp') && <PlainTopbar /> } */}
            {isAuthPath ? <AuthLayout>{children}</AuthLayout> : children}
        </div>
    )
}

export default PreLoginLayout
